import React from 'react';

const NegociacaoContext = React.createContext();

export default NegociacaoContext;